// Shared human-readable text for the RBAC escalation-guard error codes the
// server returns (403/409 `{ error: 'code' }`) on delegated-admin routes.
// Pass this map as the third argument to `errorMessage` wherever a mutation
// can be refused because the caller's granted permission doesn't cover the
// specific target/field (see server/routes/users.guards.js and the
// participant-review/assign guards on app requests).
//
// Usage:
//   import { toastError, errorMessage } from '../lib/toast';
//   import { REFUSALS } from '../lib/permissionErrors';
//   toastError(errorMessage(err, "Couldn't save the user.", REFUSALS));
export const REFUSALS = {
  privilege_exceeds_caller: 'This person has more access than you, so only an administrator can change their account.',
  admin_only_target: 'Only an administrator can change another administrator.',
  admin_only_field: 'Only an administrator can change that field.',
  self_edit_forbidden: "You can't change your own account here. Ask an administrator.",
  self_grant_forbidden: "You can't give yourself access. Ask a colleague or an administrator.",
  self_collaborator_forbidden: "You can't add yourself to an app's team.",
  participant_cannot_review: "You're on this app's team, so someone else has to review it.",
  participant_cannot_assign: "You're on this app's team, so someone else has to assign its references.",
  forbidden: "You don't have permission to do that.",
};

export default REFUSALS;
